import { Link } from "react-router-dom";
import { KRP_BUSINESS, KRP_SERVICE_AREAS } from "../../mocks/krp-data";

export default function Footer() {
  return (
    <footer className="bg-[#0C0C0C] text-white">
      {/* Top accent line */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#C9A961]/40 to-transparent" />

      <div className="max-w-screen-xl mx-auto px-6 xl:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">

          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-8">
              <img
                src="https://storage.readdy-site.link/project_files/9feb0e10-6b46-4f7c-b05e-9daa3db5d31b/728c2118-680d-47e0-a8f6-f12254ff9a4b_kitchens-renovated.png?v=dd6fc74b8793d072f57ebfceca483cce"
                alt="Kitchen Renovations Perfected"
                className="h-14 w-auto object-contain brightness-0 invert opacity-90"
                style={{ maxWidth: "180px" }}
              />
            </div>
            <p
              className="text-white/35 text-sm leading-relaxed mb-8"
              style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
            >
              South Florida&apos;s trusted family-owned design-build firm specializing in luxury kitchen and bathroom renovations.
            </p>
            {/* Rating badge */}
            <div className="inline-flex items-center gap-3 border border-[#C9A961]/20 px-4 py-3">
              <div className="flex gap-0.5">
                {[1,2,3,4,5].map((s) => (
                  <i key={s} className="ri-star-fill text-[#C9A961] text-xs" />
                ))}
              </div>
              <span className="text-white/50 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
                4.9 ({KRP_BUSINESS.reviewCount}+ reviews)
              </span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4
              className="text-white/80 text-[10px] tracking-[0.22em] uppercase font-semibold mb-7"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              <a href="/services">Our Services</a>
            </h4>
            <ul className="space-y-3.5">
              {["Kitchen Remodeling", "Bathroom Renovations", "Custom Cabinetry", "Outdoor Kitchens", "Custom Closets", "Premium Flooring"].map((s) => (
                <li key={s}>
                  <Link
                    to="/services"
                    className="text-white/35 text-sm hover:text-[#C9A961] transition-colors cursor-pointer flex items-center gap-2 group"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <span className="w-3 h-px bg-white/20 group-hover:bg-[#C9A961] transition-colors flex-shrink-0" />
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4
              className="text-white/80 text-[10px] tracking-[0.22em] uppercase font-semibold mb-7"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              <a href="/locations">Service Areas</a>
            </h4>
            <ul className="space-y-3.5">
              {KRP_SERVICE_AREAS.slice(0, 8).map((area) => (
                <li key={area}>
                  <Link
                    to="/locations"
                    className="text-white/35 text-sm hover:text-[#C9A961] transition-colors cursor-pointer flex items-center gap-2 group"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <span className="w-3 h-px bg-white/20 group-hover:bg-[#C9A961] transition-colors flex-shrink-0" />
                    {area}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-white/80 text-[10px] tracking-[0.22em] uppercase font-semibold mb-7"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Contact &amp; Location
            </h4>
            <ul className="space-y-5">
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-[#C9A961] text-sm" />
                </div>
                <span className="text-white/35 text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {KRP_BUSINESS.address}<br />{KRP_BUSINESS.city}, {KRP_BUSINESS.state} {KRP_BUSINESS.zip}
                </span>
              </li>
              <li>
                <a
                  href="tel:5614416008"
                  className="flex items-center gap-3 text-white/35 text-sm hover:text-[#C9A961] transition-colors cursor-pointer"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#C9A961] text-sm" />
                  </div>
                  {KRP_BUSINESS.phone}
                </a>
              </li>
              <li>
                <a
                  href="mailto:elliott@kitchenrp.com"
                  className="flex items-center gap-3 text-white/35 text-sm hover:text-[#C9A961] transition-colors cursor-pointer"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-[#C9A961] text-sm" />
                  </div>
                  {KRP_BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-[#C9A961] text-sm" />
                </div>
                <span className="text-white/35 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {KRP_BUSINESS.hours}
                </span>
              </li>
            </ul>
            <div className="mt-8">
              <Link
                to="/locations"
                className="inline-flex items-center gap-2 bg-[#C9A961] text-white text-[10px] tracking-[0.18em] uppercase font-semibold px-5 py-3 hover:bg-[#b8964f] transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Free Consultation
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs" />
                </div>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/6 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/20 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            &copy; {new Date().getFullYear()} Kitchen Renovations Perfected. All rights reserved. Boca Raton, FL.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-white/20 text-xs hover:text-white/50 transition-colors cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
              Privacy Policy
            </Link>
            <Link to="/" className="text-white/20 text-xs hover:text-white/50 transition-colors cursor-pointer" style={{ fontFamily: "'Inter', sans-serif" }}>
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
